@if (showName) {
  <div>
    {{playingVenueIntern.name}}
  </div>
}
@if (location) {
  <div class="pt-1 flex align-items-center">
    {{location}}
    <p-button type="submit" styleClass="p-button-rounded p-button-text" icon="pi pi-map-marker"
              (click)="openGoogleMaps()"
              [pTooltip]="'Google Maps'" [showDelay]="400"/>
  </div>
}
@if (playingVenueIntern.phone) {
  <div class="pt-1" >
    <i class="pi pi-phone text-xs pr-3" ></i>
    <span><a href="tel: {{playingVenueIntern.phone}}">{{playingVenueIntern.phone}}</a></span>
  </div>
}

@if (playingVenueIntern.numberOfBoards) {
  <div class="pt-3">
    {{'NUMBER_OF_BOARDS' | translate}}:&nbsp;{{playingVenueIntern.numberOfBoards}}
  </div>
}

<p-divider></p-divider>
<div class="pt-1" >
  <app-information-presenter [playingVenue]="playingVenueIntern" [oneRow]="true" [showAllInfos]="true" [small]="false"/>
</div>
